import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { RuleDetailsRowData } from "../utils/historyRuleDetailsRows";
import styles from "../HistoryRuleDetails.module.scss";

export const RuleDetailsGroupCell = memo(
    ({ row }: { row: { original: RuleDetailsRowData } }) => {
        const { groupColumn } = row.original;

        if (groupColumn.kind === "diff") {
            return (
                <ViewTableCell>
                    <div className={styles.removed}>
                        {groupColumn.beforeLabel}
                    </div>
                    <div className={styles.groupName}>
                        {groupColumn.afterLabel}
                    </div>
                </ViewTableCell>
            );
        }

        return (
            <ViewTableCell>
                <span className={styles.groupName}>{groupColumn.label}</span>
            </ViewTableCell>
        );
    },
);

RuleDetailsGroupCell.displayName = "RuleDetailsGroupCell";
